import { StaticPage } from './staticPage'

export const navLinks = [
  StaticPage.PRODUCTS,
  StaticPage.ABOUT,
  StaticPage.BLOG,
  StaticPage.CONTACT,
  StaticPage.PARTNERS,
] satisfies StaticPage[]
